import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'et-atoms-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputComponent {}
